import styled, { css } from "styled-components";

import CircularProgress from "common/CircularProgress/CircularProgress";
import Typography from "common/Typography/Typography";
import { Spacing } from "@paclife/plds.tokens";

const Wrapper = styled.div`
    ${({ height }) =>
        css`
            height: ${height};
        `}
    display: flex;
    justify-content: center;
    align-items: center;
    span {
        margin-left: 8px;
    }
`;

const Text = styled(Typography)`
    margin-left: ${Spacing[8]};
`;

const Loading = ({ height }) => (
    <Wrapper height={height}>
        <CircularProgress size={16} />
        <Text>Loading...</Text>
    </Wrapper>
);

export default Loading;
